import { Component, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { GooglePickerService } from 'src/app/shared/google-picker/google-picker.service';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from 'src/app/services/common.service';
import { AuthService } from 'src/app/core/auth/auth-service.service';
import { User } from 'src/app/models/auth/user.model';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { SharedSignalService } from 'src/app/services/signals.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('expand', [
      state('hide', style({
        maxHeight: '0px',
        padding: '0px 20px',
      })),
      state('show', style({
        maxHeight: '151px',
        padding: '10px 20px',
      })),
      transition('hide => show', [animate('0.5s ease')]),
      transition('show => hide', [animate('0.5s ease')]),
    ]),
  ],
  standalone: false
})
export class TopbarComponent {
  selected = 'NL';
  language: string = 'nl';
  companyName: string = ""
  user!: User;
  darkMode: boolean = false;
  photo: SafeUrl | null = null;

  constructor(
    private translate: TranslateService,
    private googlePickerService: GooglePickerService,
    private commonService: CommonService,
    private cookieService: CookieService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private sharedSignalService: SharedSignalService
  ) {
    this.language = localStorage.getItem('language') ?? 'nl';
    this.changeLanguage(this.language);
  }

  ngOnInit() {
    this.companyName = this.commonService.companyName;
    this.user = this.authService.getUser();
    this.getUserPhoto();
  }

  changeLanguage(language: string) {
    switch (language) {
      case 'en':
        this.selected = 'EN';
        this.language = 'en';
        break;
      case 'fr':
        this.selected = 'FR';
        this.language = 'fr';
        break;
      case 'nl':
        this.selected = 'NL';
        this.language = 'nl';
        break;
      default:
        this.selected = 'NL';
        this.language = 'nl';
    }
  }

  onChangeLanguage(language: string) {
    this.translate.use(language);
    localStorage.setItem('language', language);
    this.changeLanguage(language);
    this.googlePickerService.getLanguageForPicker(this.language);
  }

  selectLanguageHandler(event: any) { }

  onLogout = () => {
    this.cookieService.deleteAll();
    this.authService.logout();
  };

  toggleColorScheme(): void {
    const htmlElement = document.documentElement;

    if (this.darkMode) {
      this.darkMode = false;
      this.sharedSignalService.setTheme('light');
      htmlElement.style.setProperty('color-scheme', 'light');
      htmlElement.classList.remove('dark');
      this.cookieService.set('color-scheme', 'light');
    } else {
      this.darkMode = true;
      this.sharedSignalService.setTheme('dark');
      htmlElement.style.setProperty('color-scheme', 'dark');
      htmlElement.classList.add('dark');
      this.cookieService.set('color-scheme', 'dark');
    }
  }

  getUserPhoto() {
    if (this.user && this.user.photo) {
        this.photo = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + this.user.photo);
    } else {
        this.photo = this.sanitizer.bypassSecurityTrustUrl('../../assets/img/user-img.png');
    }
  }
}
